import axios from 'axios';

const list = () => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Checklists/`,
    withCredentials: true,
});

const item = (id) => axios({
    method: 'get',
    url: `${ process.env.VUE_APP_API_URL }/Checklists/Details/${ id }`,
    withCredentials: true,
});

const create = (element, files) => {
    const data = new FormData();
    data.set('data', JSON.stringify(element));

    const keys = Object.keys(files);
    if (keys && keys.length > 0) {
        for (let i = 0; i < keys.length; i += 1) {
            data.append(keys[i], files[keys[i]]);
        }
    }

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/Checklists/Create`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const update = (id, element, files) => {
    const data = new FormData();
    data.set('data', JSON.stringify(element));

    const keys = Object.keys(files);
    if (keys && keys.length > 0) {
        for (let i = 0; i < keys.length; i += 1) {
            data.append(keys[i], files[keys[i]]);
        }
    }

    return axios({
        method: 'post',
        url: `${ process.env.VUE_APP_API_URL }/Checklists/Update/${ id }`,
        withCredentials: true,
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const remove = (id) => axios({
    method: 'delete',
    url: `${ process.env.VUE_APP_API_URL }/Checklists/Delete/${ id }`,
    withCredentials: true,
});

const attachmentUrl = (id) => `${ process.env.VUE_APP_API_URL }/Checklists/Attachment/${ id }`;

export default {
    list,
    item,
    create,
    update,
    remove,
    attachmentUrl,
};
